import React from 'react'
import { Card, CardBody, Col, Row } from "reactstrap";

// components
import WlCardHeader from "../components/WlCardHeader";
import WlCardComment from "../components/WlCardComment";
import WishlistButtons from "../tools/WishlistButtons";

// labels
import {
    LB_ALLERGIC, LB_ALLERGIES, LB_DATE,
    LB_DURATION, LB_HOUR, LB_NAME, LB_SHARE_CABINE,
    LB_SPA, LB_TREATMENT, NO, YES_CONFIRM
} from "../../i18n/i18n";

// utils
import { getWishlistOption, wishlistTypes } from "../../../util/WishlistUtils";

const SpaViewComponent = props => {
    const option = getWishlistOption( wishlistTypes?.spa )

    return <Card className={'wl-card'}>
        <CardBody className={'wl-card-content'}>
            <WlCardHeader
                icon={ option?.icon }
                title={ option?.title }
                subTitle={props?.component?.title}
                pax={props?.component?.pax}
            />

            <div className={'wl-card-body ptb-1em mb-1em'}>
                <Row>
                    <Col>
                        <div>
                            <label className={'wl-label-title w-65px'}>{LB_DATE}</label> &nbsp;
                            <label className={'wl-label-value'}> {props?.component?.date}</label>
                        </div>
                    </Col>
                    <Col>
                        <div>
                            <label className={'wl-label-title w-55px'}>{LB_HOUR}</label> &nbsp;
                            <label className={'wl-label-value'}>{props?.component?.hour}</label>
                        </div>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <div>
                            <label className={'wl-label-title w-65px'}>{LB_TREATMENT}</label> &nbsp;
                            <label className={'wl-label-value'}> {props?.component?.treatment?.title}</label>
                        </div>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <div>
                            <label className={'wl-label-title w-65px'}>{LB_DURATION}</label> &nbsp;
                            <label className={'wl-label-value'}> { `${props?.component?.treatment?.duration}min - $${props?.component?.treatment?.price}${props?.component?.treatment?.currency}` }</label>
                        </div>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <div>
                            <label className={'wl-label-title w-65px'}>{LB_ALLERGIC}</label> &nbsp;
                            <label className={'wl-label-value'}>{props?.component?.allergic}</label>
                        </div>
                    </Col>
                    <Col>
                        <div>
                            <label className={'wl-label-title w-90px'}>{LB_SHARE_CABINE}</label> &nbsp;
                            <label
                                className={'wl-label-value'}>{props?.component?.shareCabin ? YES_CONFIRM : NO}</label>
                        </div>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <div className={'w-px'}>
                            <span className={'wl-label-title w-65px'}>{LB_ALLERGIES}</span> &nbsp;
                            <span className={'wl-label-value'}> {props?.component?.allergies}</span>
                        </div>
                    </Col>
                </Row>
            </div>

            <WlCardComment comment={props?.component?.comments}/>

            <WishlistButtons from={'wishlist'} {...props} />
        </CardBody>
    </Card>
}

export default SpaViewComponent